'use client';

import { Dispatch, FC, ReactNode, SetStateAction, useState } from 'react';
import { createContext } from 'use-context-selector';

import { checkContext } from '../context-utils';
import { STORE_USER_ROLE, StorefrontType } from './StorefrontType';

export const IntialStorefrontState: StorefrontType = {
  products: [],
  feeds: [],
  store: null,
  highlights: [],
  socialScrollDistance: 0,
  userRole: STORE_USER_ROLE.GUEST,
};

export const StorefrontContext = createContext<
  [StorefrontType, Dispatch<SetStateAction<StorefrontType>>] | null
>(null);

export const setstorefrontState = (v: [StorefrontType, Dispatch<SetStateAction<StorefrontType>>] | null) => {
  v = checkContext<StorefrontType>(v);
  return v[1];
};

export type ProviderProps = {
  storefrontContext: StorefrontType;
  children: ReactNode;
};

const StorefrontProvider: FC<ProviderProps> = ({ storefrontContext, children }) => {
  const [appState, dispatch] = useState<StorefrontType>(storefrontContext);

  return <StorefrontContext.Provider value={[appState, dispatch]}>{children}</StorefrontContext.Provider>;
};

export default StorefrontProvider;
